import { environment } from '../../../environments/environment';

export const API_URLS = {
  GATEWAY: environment.gatewayUrl,
  AUTH_SERVER: environment.authServerUrl
} as const;
